import { FC } from "react";
import { useTranslation } from "react-i18next";
import {GlobeIcon} from "src/assets/Icons";
import { LanguageService } from "src/services/Language";

const LANGUAGE_LABELS: Record<string, string> = {
  en: "English",
  ar: "العربية",
};

const LanguageSwitch: FC<{ className?: string }> = ({ className }) => {
  const { i18n } = useTranslation();
  const nextLanguage = i18n.language === "ar" ? "en" : "ar";
  return (
    <button
      type="button"
      className={
        className ??
        "flex w-full items-center gap-3 rounded-md px-4 py-2.5 text-left text-sm font-medium text-font-subtle transition-colors cursor-pointer hover:bg-background-hover"
      }
      onClick={() => LanguageService.changeLanguage(nextLanguage)}
    >
      <span className="flex h-4 w-4 items-center justify-center">
        <GlobeIcon className="h-4 w-4" />
      </span>
      {LANGUAGE_LABELS[nextLanguage]}
    </button>
  );
};

export default LanguageSwitch;
